import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { de } from 'date-fns/locale';

const customStyles = `
  .rdrDefinedRangesWrapper,.rdrDateDisplayWrapper {
    display: none;
  }
  .rdrMonthName {
    display: none;
  }
`;

const Calendar = ({ Footer = <></>, onDateSelect, dateValue, ...props }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const getDateInThreeYears = () => {
        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth();
        const day = d.getDate();
        return new Date(year + 3, month, day);
    };

    const handleSelect = ranges => {
        if (onDateSelect) {
            onDateSelect(ranges);
        }
    };

    return (
        <div className="custom-calendar">
            <style>{customStyles}</style>
            <DateRangePicker
                onChange={handleSelect}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={[dateValue]}
                direction="horizontal"
                minDate={new Date()}
                maxDate={getDateInThreeYears()}
                showDateDisplay={true}
                monthDisplayFormat="MMMM"
                showMonthAndYearPickers={true}
                showMonthArrow={true}
                locale={de}
                rangeColors={['var(--secondary)']}
                fixedHeight={true}
            />
            {Footer && Footer}
        </div>
    );
};

export default Calendar;
